<template>
<v-container class="app-page-container">
      <v-card outlined flat v-if="countries" class="mx-auto app-page-card registration-form">
        <v-card-title class="registration-form__title">
          Registration form
        </v-card-title>
        <v-card-text v-if="!registered">
          <v-flex>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-text-field label="Name:" 
                  style="margin:10px"
                  :rules="nameRules"
                  v-model="name"></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field label="Surname:" 
                  style="margin:10px"
                  :rules="nameRules"
                  v-model="surname"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-select
                  style="margin:10px"
                  v-model="country"
                  :items="myCountries"
                  label="Country:"
                >Select country</v-select>
              </v-flex>
              <v-flex xs12 md6>
              <v-select
                  style="margin:10px"
                  v-model="lang"
                  :items="myLanguages"
                  label="Environment language:"
                >Select environment language</v-select>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-text-field label="Nickname:" 
                  style="margin:10px"
                  v-model="nickName"></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                    <v-combobox
                      style="margin:10px"
                      v-model="group"
                      :items="myGroups"
                      :search-input.sync="search"
                      label="Primary group"
                      placeholder="Start typing to Search"
                    ></v-combobox>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-select
                  style="margin:10px"
                  v-model="student_type"
                  :items="student_types"
                  label="Student type:"
                >Select student type</v-select>
              </v-flex>
              <v-flex xs12 md6>
                <v-slider
                    style="margin:10px"
                    v-model="age"
                    :rules="rules.age"
                    :label="getAge()"
                    hint="Be honest, please."
                    :min="1940"
                    :max="endYear"
                    thumb-label
                  ></v-slider>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field label="E-mail:" 
                  required
                  style="margin:10px"
                  :rules="emailRules"
                  v-model="email" >
                </v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field label="Password:" v-model="passw"
                  style="margin:10px"
                  :append-icon="show1 ? 'visibility' : 'visibility_off'"
                  :rules="[rules.required, rules.min]"
                  :type="show1 ? 'text' : 'password'"
                  @click:append="show1 = !show1"
                  ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field label="Confirm password:" v-model="confpassw"
                  style="margin:10px"
                  :rules="[rules.required, rules.min]"
                  :type="show1 ? 'text' : 'password'"
                  ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <p align="center" v-if="feedback" style="color: red">{{feedback}}</p>
          </v-flex>
          <v-flex class="d-flex justify-center align-center">
            <v-checkbox v-model="agreement"/>
            I agree to the processing of my personal data in accordance with the&nbsp;<a href="#" @click.prevent="showPolicy = !showPolicy">Privacy Policy</a>&nbsp;and applicable regulations.
          </v-flex>
          <v-flex>
            
          </v-flex>
          <v-flex class="text-center">
            <!-- ps: upravene tlacidlo -->
             <v-btn :disabled="!agreement" class="btn-style btn-primary" @click="sendData()">Register</v-btn>          
          </v-flex>
          <v-card v-if="showPolicy">
            <v-icon class="btn-close" @click="showPolicy = false">close</v-icon>
            <v-card-title>Privacy policy for the Educational system PRISCILLA</v-card-title>
            <v-card-text>
              <div v-html="policy"></div>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-card-text v-if="registered">
          <v-flex xs12>
            <p></p>
            <p align="center" v-if="feedback" style="color: blue">{{feedback}}</p>
            <p></p>
          </v-flex>
        </v-card-text>

      </v-card>
</v-container>
</template>

<script>
import axios from '../../axios-auth.js'

  export default {
    data () {
      return {
        feedback: '', 
        name: '',
        surname : '',
        group: '',
        search: '',
        groups: null,
        myGroups: [],
        languages: null,
        age: 0,
        myLanguages: [],
        registered : false,
        agreement: false,
        showPolicy:false,
        emailRules: [
          v => !!v || 'E-mail is required',
          v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
         ],
        nameRules: [
            v => !!v || 'The value is required',
            v => (v && v.length >= 2 && v.length <= 40) || 'The value must be 2-40 characters',
          ],          
        lang: '',
        countries: null,
        myCountries: [],
        country: '',
        email: '',
        passw: '',
        confpassw: '',
        nickName: '',
        endYear: 0,
        show1 : false,
        student_types: ['teen student','university student'],
        student_type: 'university student',
        rules: {
          required: value => !!value || 'Required.',
          min: v => v.length >= 5 || 'Min 5 characters'
        },
        grant_type:"password",
        client_id: "2",
        client_secret: "iQuGUAzqc187j7IKQ94tTVJAywHCAzYBGAMTxEtr",
        policy:`
<p>Effective Date: 2023-01-01</p>
<h3>1. Introduction</h3><p>
We value your privacy and are committed to protecting your personal data. This Privacy Policy outlines how we collect, use, and safeguard information within our educational system. By using our system, you agree to the terms of this Privacy Policy.
</p><h3>2. Data collection</h3><p>
We collect the following personal data from users: email address, name, surname, nickname, year of birth, ip address. 
We collect activity data containing information about system interactions, such as opened resources, movement within the system, attempted answers to questions, and submissions of programs or projects.
</p><h3>3. Use of collected data</h3><p>
The data collected is used exclusively for the following purposes:
Educational research - analyzing user activity and performance to improve the educational experience and for research purposes. 
System functionality - ensuring smooth operation and user experience within the system.
</p><h3>4. Data visibility</h3><p>
Nickname visibility - other users can only see your nickname within the system. 
Teacher access - teachers can view the full name and surname of their students, along with activity and performance data. The prerequisite is that the user manually joins the group created by the teacher by entering the internal key obtained from the teacher. 
User access - users can view their own activity data, including opened resources, movement within the system, and attempts to answer questions or complete projects.
</p><h3>5. Data sharing</h3><p>
We do not share your personal data with third parties, except as required by law. 
No data is shared with external services such as Google or similar platforms.
Your data will never be sold to any third party under any circumstances.
</p><h3>6. Data protection</h3><p>
We implement robust security measures to protect your personal data, including:
Encryption of sensitive information.
Regular monitoring of system activity for unauthorized access.
Restricting data access to authorized personnel only.
</p><h3>7. Data retention</h3><p>
Your personal data will be retained for the duration of your use of the system and for research purposes as permitted by applicable laws. After this period, your data will be anonymized or deleted.
</p><h3>8. User rights</h3><p>
You have the following rights regarding your personal data:
Access to your data to corrections to inaccuracies.
Request the deletion of your personal data, subject to legal or research requirements.
Withdraw your consent to data processing at any time, which may affect your ability to use the system.
</p><h3>9. Contact information</h3><p>
For questions or concerns about this Privacy Policy, or to exercise your rights, please contact us.
</p><h3>10. Changes to this privacy policy</h3><p>
We reserve the right to update this Privacy Policy to reflect changes in legal requirements or our data practices. Any changes will be communicated through the system, and your continued use will constitute acceptance of the updated terms.
By using our educational system, you acknowledge that you have read, understood, and agree to this Privacy Policy.</p>
`
      }
    },
    methods: {
      sendData () {
        this.$store.commit('setFeedback', null)
        this.feedback = null
        if (this.name.length < 2) { 
          this.feedback = "Name is too short." 
          return 
        }
        if (this.surname.length < 2) {
          this.feedback = "Surname is too short."
          return
        }

        if (this.age == 1940) {
          this.feedback = "Please set your age - content is dependent on age too."
          return
        }  

        for(let i = 0; i<this.email.length; i++) {
          let ch = this.email.substring(i,i+1)
          let accepted = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!#$%&.@*+-/=?^_`{|}~'
          if ((accepted.indexOf(ch) > -1)) continue
            this.feedback = "Unsupported character in email address (a-z, A-Z, 0-9, !#$%&*+-/=?^_`{|}~)"
            return
        }

        if (this.email.length < 2) {
          this.feedback = "Email address is missing or too short."
          return
        }          

        if (this.passw != this.confpassw) {
          this.feedback = "Password and confirmation must be match."
          return
        }          

        var _nick = this.nickName
        if (_nick.length < 2) _nick = this.name + " " + this.surname
        var _country = this.countries[this.myCountries.indexOf(this.country)].id
        var _lang = this.languages[this.myLanguages.indexOf(this.lang)].id

        const data = {
          name: this.name,
          surname : this.surname,
          country :  _country,
          lang: _lang,
          email: this.email,
          passw: this.passw,
          nick: _nick,
          group: this.group,
          age: this.age,
          client_secret: this.client_secret,
          content_type_id: this.student_types.indexOf(this.student_type) + 1
        }

        // eslint-disable-next-line
        // console.log(data)
        axios.post('/register', data, this.$store.getters.getAxiosConfig)
          .then((res) => {
            // message
            if (res.data.message == 'OK') {
                this.feedback = 'Please check your mailbox and confirm registration (check the spam folder too).'
                this.registered = true
            } else {
                this.feedback = res.data.message
            }
        /*    const data = {
              email: this.email,
              password: this.passw,
              grant_type: this.grant_type,
              client_id: this.client_id,
              client_secret: this.client_secret,
              username: this.email
            }
            this.$store.dispatch('login', data)
          */})
          .catch(error => {
              var str = error.message            
              var _err = str.substring(str.length - 3, str.length)
              if (_err == 401) _err = 'Email "' + this.email + '" is used. Registration was aborted.'
              if (_err == 400) this.feedback = error.message
              else this.feedback = _err
          })
      },
      initData() {
        var d = new Date()
        this.endYear = d.getFullYear()
        var syslang = navigator.language || navigator.userLanguage;
        this.$store.commit('setFeedback', null)
        axios.get('/get-registration-data', this.$store.getters.getAxiosConfig)
        .then((res) => {
          // languages
          this.languages = res.data.languages
          this.myLanguages = []
          this.lang = null
          for(let i = 0; i < this.languages.length; i++) {
            this.myLanguages.push( this.languages[i].name)
            if (this.languages[i].shortcut == syslang) {             
              this.lang = this.languages[i].name
            }
          }
          if (this.lang == null) this.lang = this.myLanguages[0]
          // countries
          this.countries = res.data.countries
          this.myCountries = []
          for(let i = 0; i < this.countries.length; i++) {
            this.myCountries.push( this.countries[i].country_name)
          }
          this.country = this.myCountries[0]
          // groups
          this.groups = res.data.groups
          this.myGroups = []
          for(let i = 0; i < this.groups.length; i++) {
            this.myGroups.push( this.groups[i].group_name)
          }          
        })
        .catch(error => {
          this.$store.commit('setFeedback', error)          
        })
      },
      getAge() {
        return "Y.of birth: " + this.age
      },
      goToLogin() {
        this.$router.push({name:'login', params: {} }) 
      }
    },
    mounted() {
      this.initData()
    }
  }
</script>
